import React from 'react'
import PropTypes from 'prop-types'

// NOTIFY KAYLA IF YOU MAKE ANY CHANGES TO THIS FILE

class DivButton extends React.Component {
  render() {
    // split props into children and everything else (rest)
    const { children, className = '', ...rest } = this.props
    // create divProps and make it equal to everything that was in props (rest) but override the onClick
    const modifiedClassName = `${className} div-button`
    const divProps = {
      ...rest,
      onClick: this.props.disabled ? () => null : this.props.onClick,
      className: this.props.disabled
        ? `${modifiedClassName} disabled`
        : modifiedClassName
    }
    return <div {...divProps}>{this.props.children}</div>
  }
}

DivButton.defaultProps = {
  disabled: false,
  onClick: () => {}
}

DivButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func
}

export default DivButton
